import FanOperationType from "src/consts/FanOperationType";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import React from "react";
import NoOperationsCard from "./NoOperationsCard";
import DryerOperationsCard from "./DryerOperationsCard";
import FanOperationsCard from "./FanOperationsCard";
import GrainMovingOperationsCard from "./GrainMovingOperationsCard";

interface NoticeCardSectionCoreProps{
    binDto: PremierPlusBinDTO | null;
    handleShowFanSettingsModal: () => void;
    handleShowDryerSettingsModal: () => void;
    handleClickViewGrainMoving: () => void;
    handleClickViewFan: () => void;
    handleClickViewDrying: () => void;
}

const NoticeCardSectionCore = ({ binDto, handleShowFanSettingsModal, handleClickViewGrainMoving, handleClickViewFan, handleShowDryerSettingsModal, handleClickViewDrying }: NoticeCardSectionCoreProps) => {
    
    if(binDto?.dryingOperation?.isRunning)
    {
        return(
            <DryerOperationsCard 
            binDto={binDto}
            handleShowDryerSettingsModal={handleShowDryerSettingsModal}
            handleClickViewDrying={handleClickViewDrying}
            />
        )
    }

    const fanOperationRunning = binDto?.fanRunOperation?.fanOperationType != FanOperationType.Off;
    const grainMovingOperationRunning = binDto?.grainMovingOperation?.isGrainMoving == true;

    if(fanOperationRunning || grainMovingOperationRunning){
        return(
            <>
                {
                    fanOperationRunning && 
                    <FanOperationsCard 
                    binDto={binDto} 
                    handleShowFanSettingsModal={handleShowFanSettingsModal} 
                    handleClickViewFan={handleClickViewFan}
                    />
                }
                {
                    grainMovingOperationRunning && 
                    <GrainMovingOperationsCard 
                    binDto={binDto} 
                    handleClickViewGrainMoving={handleClickViewGrainMoving}
                    />
                }
            </>
        )
    }

    return(
        <NoOperationsCard 
        binDto={binDto} 
        handleShowFanSettingsModal={handleShowFanSettingsModal} 
        /> 
    );
}

export default NoticeCardSectionCore;